<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <!-- Navigation header -->
    <AppHeader :user-name="currentUserName" />
    
    <!-- Navigation indicator -->
    <NavigatingIndicator :visible="uiStore.navigating" />
    
    <!-- Connection warning -->
    <div v-if="uiStore.connectionWarning" class="alert alert-warning mb-0" role="alert">
      <div class="container">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        Connection issues detected. Retrying...
      </div>
    </div>
    
    <main class="container mt-4 flex-grow-1">
      <router-view />
    </main>
    
    <!-- Application footer -->
    <AppFooter />
    
    <!-- Global loading spinner -->
    <LoadingSpinner :visible="uiStore.globalLoading" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUIStore } from './stores/ui'
import { useVoterStore } from './stores/voter'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import NavigatingIndicator from './components/NavigatingIndicator.vue'

const uiStore = useUIStore()
const voterStore = useVoterStore()

// Compute current user name for header display
const currentUserName = computed(() => {
  // Show user name when voter session exists
  if (voterStore.currentVoter) {
    return voterStore.currentVoter.voterName
  }
  return undefined
})
</script>

<style scoped>
/* Removed min-height as it's now handled by d-flex flex-column min-vh-100 classes */
</style>
